import { render, staticRenderFns } from "./partners-bar-chart.vue?vue&type=template&id=57765bf3&scoped=true"
import script from "./partners-bar-chart.ts?vue&type=script&lang=ts&external"
export * from "./partners-bar-chart.ts?vue&type=script&lang=ts&external"
import style0 from "./partners-bar-chart.scss?vue&type=style&index=0&id=57765bf3&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57765bf3",
  null
  
)

export default component.exports